import { gspx } from '@rsos/gainsight';

export const toggleGroupCheckboxTracking = (
  isAnyLayerChecked,
  name,
  irpVersion,
) => {
  // layer.isChecked is in previous state here before reset
  // if is on, turn off layer
  // if is off, turn on layer
  const onOffText = isAnyLayerChecked ? 'off' : 'on';

  gspx.trackCustomEvent('Data Map', {
    irpVersion,
    name: `Turn ${onOffText} ${name}`,
    Category: 'Spatial Layer',
    'Launched date': new Date(),
  });
};
